import { FC, memo } from 'react'
import { PlaceholderCell } from 'components/extend/PlaceholderCell'
import { formatDateToMoscow } from 'helpers/dates'
import { TDeliveryInfoDateResponse } from 'modules/deliveryInfo/types'
import CalendarIcon from 'remixicon/icons/Business/calendar-line.svg?react'

interface OrderYarcheCreateSummaryDeliveryDateProps {
  isLoading: boolean
  deliveryDate?: TDeliveryInfoDateResponse['deliveryDate']
}

const OrderYarcheCreateSummaryDeliveryDate: FC<OrderYarcheCreateSummaryDeliveryDateProps> = ({
  deliveryDate,
  isLoading
}) => (
  <>
    {isLoading ? (
      <PlaceholderCell height={20} />
    ) : (
      <div className="flex gap-2 text-body-md">
        <CalendarIcon className="text-on-surface-variant" containerSize="sm" size="xs" />
        <div>Плановая дата доставки</div>
        <div className="ml-auto">
          {deliveryDate?.destinationTerminalDate ? formatDateToMoscow(deliveryDate?.destinationTerminalDate) : '—'}
        </div>
      </div>
    )}
  </>
)

export default memo(OrderYarcheCreateSummaryDeliveryDate)
